var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForm21Ico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 36,
    viewBox: "0 0 61 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5469 35.7835H0.361328V22.0146C0.361328 20.1888 1.28094 18.4377 2.91786 17.1466C4.55477 15.8555 6.7749 15.1302 9.08985 15.1302H17.8184V8.24576H0.361328V1.36133H17.8184C20.1333 1.36133 22.3535 2.08665 23.9904 3.37773C25.6273 4.66882 26.5469 6.4199 26.5469 8.24576V15.1302C26.5469 16.9561 25.6273 18.7071 23.9904 19.9982C22.3535 21.2893 20.1333 22.0146 17.8184 22.0146H9.08985V28.8991H26.5469V35.7835Z",
    fill: "#473080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7634 26.5463V0H45.0488V3.31829H37.3342V9.95486H45.0488V26.5463H37.3342V33.1829H60.478V26.5463H52.7634Z",
    fill: "#473080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm21Ico);
export default __webpack_public_path__ + "static/media/form21Ico.79f76cbc071c69775a37ec25656c7ddb.svg";
export { ForwardRef as ReactComponent };